import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "728f3eac-bc01-493c-94ee-0f6e55729902" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#728f3eac-bc01-493c-94ee-0f6e55729902)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h167l45.6 257.6L167.1 512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M167 0h345v256l-176.7 53.5L166.9 256z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M167 256h345v256H167z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ a({
  __name: "mg",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        g,
        v
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=mg-a2b58b39.js.map
